export const getStandings = (state, division) =>
  state.standingsReducer[division];



// WEBPACK FOOTER //
// ./src/store/standings/standingsSelectors.js